import { useState, useEffect, useCallback } from 'react';
import client from '../api/client';

/**
 * Fetch active golf tournaments from /api/sports, then fetch odds for each.
 * Golf sport keys look like "golf_masters_tournament_winner", etc.
 */
export default function useGolfOdds() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const sportsRes = await client.get('/api/sports');
      const golfSports = (sportsRes.data || []).filter(
        (s) => s.key.startsWith('golf_') && s.active,
      );

      if (golfSports.length === 0) {
        setTournaments([]);
        setLoading(false);
        return;
      }

      const results = await Promise.all(
        golfSports.map(async (gs) => {
          try {
            const res = await client.get(`/api/odds/${gs.key}`);
            return { sport: gs, events: res.data || [] };
          } catch {
            return { sport: gs, events: [] };
          }
        }),
      );

      setTournaments(results.filter((r) => r.events.length > 0));
    } catch (err) {
      setError(err.message);
      setTournaments([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { tournaments, loading, error, refetch: fetch };
}
